import { render, staticRenderFns } from "./MadMixRostersScreen.vue?vue&type=template&id=5e2a20c8&scoped=true"
import script from "./MadMixRostersScreen.vue?vue&type=script&lang=js"
export * from "./MadMixRostersScreen.vue?vue&type=script&lang=js"
import style0 from "./MadMixRostersScreen.vue?vue&type=style&index=0&id=5e2a20c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a20c8",
  null
  
)

export default component.exports